/**
 * @flow
 * @relayHash 58c76782a903be98dcb9966c937e6435
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type pickemGameQuestionAnswerInputType = {|
  game_id: string,
  guest_id: string,
  quarter_id: string,
|};
export type ChapterStatusQueryVariables = {|
  args?: ?pickemGameQuestionAnswerInputType
|};
export type ChapterStatusQueryResponse = {|
  +getGuestGameQuestionAnswerCount: ?{|
    +code: ?number,
    +message: ?string,
    +data: ?{|
      +current_chapter_data: ?{|
        +chapter_id: ?number,
        +number_of_questions: ?number,
        +number_of_tiebreaker_questions: ?number,
        +number_of_answered_questions: ?number,
        +number_of_answered_tiebreaker: ?number,
        +number_of_correct_answers: ?number,
      |}
    |},
  |}
|};
export type ChapterStatusQuery = {|
  variables: ChapterStatusQueryVariables,
  response: ChapterStatusQueryResponse,
|};
*/


/*
query ChapterStatusQuery(
  $args: pickemGameQuestionAnswerInputType
) {
  getGuestGameQuestionAnswerCount(arguments: $args) {
    code
    message
    data {
      current_chapter_data {
        chapter_id
        number_of_questions
        number_of_tiebreaker_questions
        number_of_answered_questions
        number_of_answered_tiebreaker
        number_of_correct_answers
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "args",
    "type": "pickemGameQuestionAnswerInputType",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "getGuestGameQuestionAnswerCount",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "arguments",
        "variableName": "args"
      }
    ],
    "concreteType": "pickemGameQuestionAnswerType",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "code",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "message",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "data",
        "storageKey": null,
        "args": null,
        "concreteType": "pickemGameQuestionAnswerDataType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "current_chapter_data",
            "storageKey": null,
            "args": null,
            "concreteType": "chapterWiseQuestionAnswerCount",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "chapter_id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "number_of_questions",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "number_of_tiebreaker_questions",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "number_of_answered_questions",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "number_of_answered_tiebreaker",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "number_of_correct_answers",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ChapterStatusQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ChapterStatusQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "ChapterStatusQuery",
    "id": null,
    "text": "query ChapterStatusQuery(\n  $args: pickemGameQuestionAnswerInputType\n) {\n  getGuestGameQuestionAnswerCount(arguments: $args) {\n    code\n    message\n    data {\n      current_chapter_data {\n        chapter_id\n        number_of_questions\n        number_of_tiebreaker_questions\n        number_of_answered_questions\n        number_of_answered_tiebreaker\n        number_of_correct_answers\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '18719e276b0f6b62a7edc1372769ce68';
module.exports = node;
